import { render, staticRenderFns } from "./arrow-left.vue?vue&type=template&id=44bb7e73&scoped=true&"
var script = {}
import style0 from "./arrow-left.vue?vue&type=style&index=0&id=44bb7e73&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bb7e73",
  null
  
)

export default component.exports